const authGuard = (meta) => meta.dispatch(authGuardAction(meta));

const authGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	const checkPath = [
		"/login",
		"/installation",
		"/software-update",
	];

	if (!state.auth.loggedIn && !(checkPath.includes(to?.location?.currentPath)) ) {
		return '/login'
	}

	return null
}

export { authGuard };
